import { render } from "./PlaylistTracks.vue?vue&type=template&id=3c96b7b5"
import script from "./PlaylistTracks.vue?vue&type=script&lang=js"
export * from "./PlaylistTracks.vue?vue&type=script&lang=js"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__